//const { parse } = require("angular-ui-router"); // not sure what this is but causing errors

//const { pack } = require("d3");

$(document).ready(function () {
    "use strict";

    //For tab reloads and actions
    var hash = location.hash.replace(/^#/, ""); // ^ means starting, meaning only match the first hash
    var prefix = "tab_";
    if (hash) {
        $('.nav-tabs a[href="#' + hash.replace(prefix, "") + '"]').tab("show");
    }

    // Change hash for page-reload --> https://stackoverflow.com/questions/7862233/twitter-bootstrap-tabs-go-to-specific-tab-on-page-reload-or-hyperlink
    $(".nav-tabs a").on("shown.bs.tab", function (e) {
        window.location.hash = e.target.hash.replace("#", "#" + prefix);
    });

    $("#select_all").click(function () {
        $(".select_all_checkbox").prop("checked", this.checked);
    });

    $(document).on("change", "#productPackageEditForm #units", function () {});




function selectAllCheckbox() {
    if (
        $(".select_all_checkbox:checked").length ==
        $(".select_all_checkbox").length
    ) {
        $("#select_all").prop("checked", true);
    } else {
        $("#select_all").prop("checked", false);
    }
}

function actionFunc(value) {
    if (value === "assign_employee") {
        $(".employeeListComponent").removeClass("d-none");
    }
    return value;
}

function applyActionValidation() {
    var actions = $("#actions");
    var employeeId = $("#employee_id");
    var checkBoxRows = $(".select_all_checkbox");
    var orderIdArry = [];

    if (!actions.val()) {
        var message = "No action is selected";
        showNotification(message, message, "gritter-red");
        actions.focus();
        return false;
    }

    checkBoxRows.each((index, checkboxElement) => {
        const isChecked = $(checkboxElement).is(":checked");

        if (isChecked) {
            orderIdArry.push($(checkboxElement).val());
        }
    });

    if (actions.val() && employeeId.val() && orderIdArry.length <= 0) {
        var message = "No order is checked";
        showNotification(message, message, "gritter-red");
        return false;
    }

    return {
        actions: actions.val(),
        employee_id: employeeId.val(),
        orders: orderIdArry,
    };
}

function applyAction(URL) {
    var validData = applyActionValidation();

    if (validData.actions === "assign_employee") {
        $.ajax({
            url: URL,
            method: "get",
            dataType: "json",
            data: validData,
        });
    }
}

function showNotification(errorMessage, message, className) {
    // Replace this with your preferred notification method (e.g., Toastr, Bootstrap alerts, etc.)
    $.gritter.add({
        title: message,
        text: errorMessage,
        image: "",
        sticky: true,
        time: "",
        class_name: `my-sticky-class ${className}`,
        before_open: function () {},
        after_open: function (e) {},
        before_close: function (manual_close) {},
        after_close: function (manual_close) {},
    });
}

function createPkgValidation(shipmentId) {
    var packname = $(`#new_added_packname_${shipmentId}`);

    if (!packname.val()) {
        showNotification(
            "Invalid Package Name",
            "Package Form Validation",
            "gritter-red"
        );
        return false;
    }

    var weight = $(`#new_added_weight_${shipmentId}`);

    if (!weight.val()) {
        showNotification(
            "Invalid Weight",
            "Package Form Validation",
            "gritter-red"
        );
        return false;
    }

    return {
        packname: packname.val(),
        weight: weight.val(),
        units: $(`#new_added_units_${shipmentId}`).val(),
        width: $(`#new_added_width_${shipmentId}`).val() ?? null,
        length: $(`#new_added_length_${shipmentId}`).val() ?? null,
        height: $(`#new_added_height_${shipmentId}`).val() ?? null,
        reference1: $(`#new_added_reference1_${shipmentId}`).val() ?? null,
        reference2: $(`#new_added_reference2_${shipmentId}`).val() ?? null,
        print_copies: $(`#new_added_print_copies_${shipmentId}`).val() ?? null,
        add_package_tags: $(`#add_package_tags_${shipmentId}`).val() ?? null,
        shipment_id: shipmentId,
    };
}

function addPkg(orderId, shipmentId) {
    const validData = createPkgValidation(shipmentId);
    if (!validData) {
        return false;
    }

    $.ajax({
        url: `/orders/${orderId}/packages/store`,
        method: "POST",
        dataType: "JSON",
        data: validData,
        success: (data, msg) => {
            if (data) {
                var orderPkgElement = $(`#create_order_packages_${shipmentId}`);
                orderPkgElement.append(`
                    <tr id="product_package_element_${
                        data.id
                    }" class="package_group">
                    <td id="row_packname_${data.id}" class="package_names">${
                    data.name
                }</td>
                    <td id="row_weight_${data.id}" class="weights_${shipmentId}" >${
                    data.weight
                } <span id="row_units_${data.id}" class="units_${shipmentId}">${data.units}</span> </td>
                    <td id="row_tags_${
                        data.id
                    }" class="row_product_package_tags" >${data.tags
                    .map((item) => item.name.en)
                    .join(", ")}</td>
                    <td>
                        <input id="row_length_${data.id}" class="length" value="${
                    data.length ?? 0
                }" type="hidden"/>
                        <input id="row_height_${data.id}" class="height" value="${
                    data.height ?? 0
                }" type="hidden"/>
                        <input id="row_width_${data.id}" class="width" value="${
                    data.width ?? 0
                }" type="hidden"/>
                        <input id="row_reference1_${
                            data.id
                        }" class="reference1" value="${
                    data.reference1 == "null" ? "" : data.reference1
                }" type="hidden"/>
                        <input id="row_reference2_${
                            data.id
                        }" class="reference2" value="${
                    data.reference2 == "null" ? "" : data.reference2
                }" type="hidden"/>
                        <input id="row_print_copies_${
                            data.id
                        }" class="print_copies" value="${
                    data.print_copies ?? 1
                }" type="hidden"/>
                        <input id="create_row_id" type="hidden" class="row_ids" name="row_id[${
                            data.id
                        }]" value="${data.id}" />
                        <a href="javascript:void(0)" class="btn btn-primary w-55px py-2" onclick="editPackage('${
                            data.id
                        }', '${
                    data.id
                }', '${shipmentId}')"> <i class="fas fa-lg fa-fw fa-pencil"></i> </a>
                        <a href="javascript:void(0)" class="btn btn-danger w-55px py-2" onclick="removeAddedPkgRow('${
                            data.id
                        }', '${orderId}', '${shipmentId}')"><i class="fa fa-trash"></i></a>
                    </td>
                </tr>`);
                    console.log(data.id)
                $("#add-modal").append(`<div class="modal fade" id="editPackageModal_${data.id}" tabindex="-1" aria-labelledby="editPackageModal" aria-hidden="true">
                <div class="modal-dialog modal-xl">
                    <div class="modal-content" style="background:var(--bs-body-bg)">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Edit Package</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                        <div class="row">
                    <div class="col-xl-8">
                        <div class="card  mb-2">
                            <div class="card-header bg-white h6 mb-0 p-3">
                                <i class="fa fa-dolly fa-lg fa-fw text-dark text-opacity-50 me-1"></i>Package Info</div>
                            <div class="card-body">
                                <div class="mb-3">
                                    Package Name
                                    <input type="hidden" name="product_package_id" id="product_package_id_${
                                        data.id
                                    }" value="${data.product_package_id}">
                                    <input type="text" name="packname" id="packname_${
                                        data.id
                                    }" class="form-control" value="${
                    data.name
                }">
                                    <p class="text-danger" id="packnamemsg_${
                                        data.id
                                    }"></p>
                                </div>
                            </div>
                        </div>

                        <div class="card border-0 mb-2">
                            <div class="card-header h6 mb-0 bg-none p-3">
                                <i class="fa fa-box fa-lg fa-fw text-dark text-opacity-50 me-1"></i> Package Details
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="mb-3">
                                            <div class="form-group">
                                                <label class="form-label">Weight</label>
                                                <div class="row gx-1">
                                                    <div class="col-4">
                                                        <div class="input-group">
                                                            <input type="number" id="weight_${
                                                                data.id
                                                            }" name="weight" step="0.1" placeholder="10" value="${
                    data.weight
                }" class="form-control" />
                                                            <p class="text-danger" id="weightmsg"></p>
                                                        </div>
                                                    </div>
                                                    <div class="col-7">
                                                        <div class="input-group">
                                                            <select name="units" id="units_${
                                                                data.id
                                                            }" class="form-select" onchange="convertUOM(this.value, '${
                    data.id
                }')">
                                                                <option value="pounds" ${
                                                                    data.units ===
                                                                    "pounds"
                                                                        ? "selected"
                                                                        : ""
                                                                }>Pounds</option>
                                                                <option value="ounces" ${
                                                                    data.units ===
                                                                    "ounces"
                                                                        ? "selected"
                                                                        : ""
                                                                }>Ounces</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label class="form-label">Package Size In Inches</label>
                                            <div class="row">
                                                <div class="col-4">
                                                    <div class="input-group">
                                                        <span class="input-group-text">W</span>
                                                        <input type="number" name="width" id="width_${
                                                            data.id
                                                        }" class="form-control" step="0.1" placeholder="10" id="width" value="${
                    data.width
                }"/>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="input-group">
                                                        <span class="input-group-text">L</span>
                                                        <input type="number" name="length" id="length_${
                                                            data.id
                                                        }" class="form-control" step="0.1" placeholder="10" id="length" value="${
                    data.length
                }"/>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="input-group">
                                                        <span class="input-group-text">H</span>
                                                        <input type="number" name="height" id="height_${
                                                            data.id
                                                        }" class="form-control" step="0.1" placeholder="10" id="height" value="${
                    data.height
                }"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4">
                        <div class="card border-0 mb-4">
                            <div class="card-header h6 mb-0 bg-none p-3 d-flex">
                                <div class="flex-1">
                                    <div>Package References</div>
                                </div>
                            </div>
                            <div class="card-body fw-bold">
                                <div class="">
                                    <div class="mb-3">
                                        Reference 1:
                                        <input type="text" name="reference1" class="form-control" id="reference1_${
                                            data.id
                                        }" value="${data.reference1 ?? ""}" />
                                    </div>
                                    <div class="mb-3">
                                        Reference 2:
                                        <input type="text" name="reference2" class="form-control" id="reference2_${
                                            data.id
                                        }" value="${data.reference2 ?? ""}" />
                                    </div>
                                    <div class="mb-3">
                                        Copies
                                        <input type="number" name="print_copies" class="form-control" id="print_copies_${
                                            data.id
                                        }" value="${data.print_copies}" />
                                        <p class="text-danger" id="printCopiesmsg"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card border-0">
                            <div class="card-header h6 mb-0 bg-none p-3 d-flex">
                                <div class="flex-1">
                                    <div>Tags</div>
                                </div>
                            </div>

                            <div class="card-body fw-bold">
                                <div class="">
                                    <div class="mb-3">
                                        <input type="text" id="edit_package_tags_${
                                            data.id
                                        }" name="package_tags" class="form-control" value="${data.tags.map(
                    (tag) => tag.name.en
                )}">
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                                        </div>

                                        <div class="modal-footer d-flex justify-content-between">
                                            <a href="javascript:void(0)" class="btn btn-white" data-bs-dismiss="modal">Close</a>
                                            <div>
                                                <button type="button" class="btn btn-sm btn-primary w-100px" id="editPackageButton" onclick="updatePkg('${orderId}', '${shipmentId}', '${
                    data.id
                }')">Update</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>`);

                var modalElement = document.getElementById(
                    `addPackageModal_${shipmentId}`
                );
                var modal = bootstrap.Modal.getInstance(modalElement);
                modal.hide();

                resetCreatePackgeForm(shipmentId);
                fetchRatings(orderId, shipmentId);
            }
        },
        error: (data, msg) => {
            console.log(data, msg);
        },
    });
}

function resetCreatePackgeForm(shipmentId) {
    $("#new_added_packname_" + shipmentId).val("");
    $("#new_added_weight_" + shipmentId).val(0);
    $("#new_added_width_" + shipmentId).val("");
    $("#new_added_length_" + shipmentId).val("");
    $("#new_added_height_" + shipmentId).val("");
    $("#new_added_reference1_" + shipmentId).val("");
    $("#new_added_reference2_" + shipmentId).val("");
    $("#new_added_print_copies_" + shipmentId).val("1");
    $("#add_package_tags").val("");
}

function resetPackageList(shipmentNumber) {
    $(`#order_packages_${shipmentNumber}`).html("");
    $(`#create_order_packages_${shipmentNumber}`).html("");
}

function resetTopSection() {
    $("#customer_name").val("");
    $("#customer_username").val("");
    $("#customer_email").val("");
    $("#phone_number").val("");
    $("#phone_number").val("");
    $("#company").val("");
    $("#street1").val("");
    $("#street2").val("");
    $("#street3").val("");
    $("#state").val("");
    $("#city").val("");
    $("#postal_code").val("");
    $("#country").val("");
}

function resetMidSection() {
    $("#customer_note").val("");
    $("#internal_note").val("");
    $("#custom_field1").val("");
    $("#custom_field2").val("");
    $("#custom_field3").val("");
}

function resetAll() {
    resetTopSection();
    resetMidSection();
    resetCreatePackgeForm();
    resetPackageList();
    resetProductList();
}

function removeAddedPkgRow(rowId, orderId) {
    $(`#product_package_element_${rowId}`).remove();
    updateProductOrder(orderId);
}

function removeUpdatedPkgRow(pkgId, shipmentId, orderId) {

    if (confirm("Are you sure, you want to remove this package?")) {
        $.ajax({
            url: `/orders/package/remove/${pkgId}`,
            method: "DELETE",
            dataType: "json",
            success: (data, msg) => {
                if (data == true) {
                    $(`#product_package_element_${pkgId}`).remove();
                    fetchRatings(orderId, shipmentId);
                }
            },
            error: (data, msg) => {
                console.log(data, msg);
            },
        });
    }

}

function updateJustAddedPkg(shipmentNumber) {
    var rowId = document.getElementById(
        `new_added_row_id_${shipmentNumber}`
    ).value;

    // Check if the array and rowId are valid
    if (rowId) {
        // Get the updated values from the form
        var updatedPackage = {
            rowId: rowId,
            data: {
                packname: document.getElementById(
                    `new_added_packname_${shipmentNumber}`
                ).value,
                weight: document.getElementById(
                    `new_added_weight_${shipmentNumber}`
                ).value,
                units: document.getElementById(
                    `new_added_units_${shipmentNumber}`
                ).value,
                width: document.getElementById(
                    `new_added_width_${shipmentNumber}`
                ).value,
                length: document.getElementById(
                    `new_added_length _${shipmentNumber}`
                ).value,
                height: document.getElementById(
                    `new_added_height_${shipmentNumber}`
                ).value,
                reference1: document.getElementById(
                    `new_added_reference1_${shipmentNumber}`
                ).value,
                reference2: document.getElementById(
                    `new_added_reference2_${shipmentNumber}`
                ).value,
                print_copies: document.getElementById(
                    `new_added_print_copies_${shipmentNumber}`
                ).value,
                add_package_tags: document.getElementById(
                    `add_package_tags_${shipmentNumber}`
                ).value,
            },
        };

        // Update the HTML elements
        $(`#packname_${rowId}`).html(updatedPackage.data.packname);
        $(`#weight_${rowId}`).html(updatedPackage.data.weight);
        $(`#tags_${rowId}`).html(updatedPackage.data.add_package_tags);
        $(`#units_${rowId}`).html(updatedPackage.data.units);

        $(`#addPackageButton_${shipmentNumber}`).removeClass("d-none");
        $(`#updatePackageButton_${shipmentNumber}`).addClass("d-none");
        $(`#row_id_scope_${shipmentNumber}`).html("");

        var modalElement = document.getElementById(
            `addPackageModal_${shipmentNumber}`
        );
        var modal = bootstrap.Modal.getInstance(modalElement);
        modal.hide();
        resetCreatePackgeForm();
    } else {
        console.log("No packages found in local storage or invalid format");
    }
}

function updatePkg(orderId, shipmentId, pkgId) {
    // Get the values from the input fields
    var productPkgId = $("#product_package_id_" + pkgId).val() ?? null;
    var packname = $("#packname_" + pkgId).val();

    if (!packname) {
        return false;
    }

    var weight = $("#weight_" + pkgId).val();
    var edit_package_tags = $(`#edit_package_tags_${pkgId}`).val();
    var length = $("#length_" + pkgId).val();
    var height = $("#height_" + pkgId).val();
    var width = $("#width_" + pkgId).val();
    var reference1 = $("#reference1_" + pkgId).val();
    var reference2 = $("#reference2_" + pkgId).val();
    var print_copies = $("#print_copies_" + pkgId).val();
    var units = $("#units_" + pkgId).val();

    var updatedData = {
        packname: packname,
        product_packages_id: productPkgId,
        weight: weight,
        edit_package_tags: edit_package_tags,
        length: length,
        height: height,
        width: width,
        reference1: reference1,
        reference2: reference2,
        print_copies: print_copies,
        units: units,
    };

    $.ajax({
        url: `/orders/${shipmentId}/packages/update/${pkgId}`,
        method: "POST",
        dataType: "JSON",
        data: updatedData,
        success: (data, msg) => {
            $(`#row_packname_${pkgId}`).html(data.name);
            $(`#row_weight_${pkgId}`).html(`${data.weight} ${data.units}`);
            $(`#row_tags_${pkgId}`).html(
                data.tags.map((item) => item.name.en).join(", ")
            );
            $(`#row_length_${pkgId}`).val(data.length);
            $(`#row_height_${pkgId}`).val(data.height);
            $(`#row_width_${pkgId}`).val(data.width);
            $(`#row_reference1_${pkgId}`).val(data.reference1);
            $(`#row_reference2_${pkgId}`).val(data.reference2);
            $(`#row_print_copies_${pkgId}`).val(data.print_copies);

            var myModal = bootstrap.Modal.getInstance(
                document.getElementById("modal-edit-package")
            );
            myModal.hide();

            fetchRatings(orderId, shipmentId);
        },
        error: (data, msg) => {
            console.log(data, msg);
        },
    });
}

function updateOrder(orderId) {
    var $orderForm = $("#order_create_form").serializeArray();

    $.ajax({
        url: `/orders/update/draft/${orderId}/order`,
        method: "PATCH",
        dataType: "json",
        data: $orderForm,
        success: (data, msg) => {
            //
        },
        error: (data, msg) => {
            console.log(data, msg);
        },
    });
}

function addNewShipment(orderId, url) {
    const shipmentNumber = $(".shipment_number").length;

    $.ajax({
        url: url,
        method: "get",
        contentType: "text/plain",
        data: {
            shipment_number: shipmentNumber,
        },

        success: (data, msg) => {
            $("#new_shipment").append(data);
        },
        error: (data, msg) => {
            console.log(data, msg);
        },
    });
}

async function removeShipment(URL) {
    if (confirm("Are you sure?")) {
        try {
            const response = await $.ajax({
                url: URL,
                method: "DELETE",
                dataType: "json",
            });

            // Handle success (response)
            console.log("Success:", response.id);

            $(`[data-shipment-index="${response.id}"]`).remove();
        } catch (error) {
            // Handle error
            console.error("Error:", error);
        }
    } else {
        return false;
    }
}

function confirmOrder(url) {
    $.ajax({
        url: url,
        dataType: "json",
        success: (data, msg) => {
            console.log(data, msg);
        },
        error: (data, msg) => {
            console.log(data, msg);
        },
    });
}

function addNewProductRow(url, shipmentNumber, shipmentId, orderId) {
    const productId = $("#products_id_0");
    const quantity = $("#quantity_0");
    const tags = $("#tags_0");

    const data = {
        product_id: productId.val(),
        quantity: quantity.val(),
        product_tags: tags.val(),
        shipmentNumber: shipmentNumber,
        rowId: Math.random().toString(36).substring(2, 7),
        shipment_id: shipmentId,
    };

    $.ajax({
        url: url,
        method: "POST",
        dataType: "json",
        data: data,
        success: (data, msg) => {

            if (data) {
                $("#product_rows").html(data.orders_products);
                console.log(shipmentId)
                console.log(`#create_order_packages_${shipmentId}`)
                $(`#create_order_packages_${shipmentId}`).append(
                    data.orders_packages
                );

                fetchRatings(orderId, shipmentId);
            }
        },
        error: (data, msg) => {
            console.log(data, msg);
        },
    });
}

function updateProducts(detailsId, actionType, productDetailUrl) {
    $.ajax({
        url: productDetailUrl,
        dataType: "json",
        method: "get",
        data: {
            action_type: actionType,
        },
        success: (data, msg) => {
            if (data && data.views) {
                $("#row_id_" + detailsId).html(data.views);

                $(".product_tags").tagit({
                    availableTags: availableTags,
                    showAutocompleteOnFocus: true,
                    allowSpaces: true,
                    beforeTagAdded: function (event, ui) {
                        if (
                            $.inArray(
                                ui.tagLabel.toLowerCase(),
                                availableTags.map(function (tag) {
                                    return tag;
                                })
                            ) == -1
                        ) {
                            return true;
                        }
                        return true;
                    },
                });
            }
        },
        error: (jqXHR, textStatus, errorThrown) => {
            console.error('Error fetching product details:', {
                url: productDetailUrl,
                status: jqXHR.status,
                statusText: textStatus,
                error: errorThrown,
                response: jqXHR.responseText
            });
            showNotification('Error loading product details', 'Error', 'gritter-red');
        },
    });
}

function updateDetailsProduct(detailsId, actionType, URL) {
    var productDetails = {};
    productDetails.quantity = $("#quantity").val();
    productDetails.tags = $("#tags").val();
    productDetails.actionType = actionType;

    if (productDetails) {
        $.ajax({
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            url: URL,
            dataType: "json",
            method: "PUT",
            data: productDetails,
            success: (data, msg) => {
                if (data) {
                    $(`#row_id_${detailsId}`).html(data.order_products);
                    $(`#create_order_packages_0`).html(data.orders_packages);
                }
            },
            error: (data, msg) => {
                console.log(data, msg);
            },
        });
    }
}

function deleteOrderProducts(URL, productId, detailsId) {
    if (confirm("Are you sure?")) {
        $.ajax({
            url: URL,
            method: "POST",
            dataType: "JSON",
            data: {
                product_id: productId,
                detailsId: detailsId,
            },
            success: (data, msg) => {
                if (data) {
                    $(`#row_id_${detailsId}`).remove();
                    $(`#create_order_packages_0`).html(data.orders_packages);
                }
            },
            error: (data, msg) => {
                console.log(data, msg);
            },
        });
    }
}

function fetchRatings(orderId, shipmentId) {
    const button = $(`#resetBtn${shipmentId}`);

    //not needed, this has been moved to server side
    /* const elements = $(`.weights_${shipmentId}`);
    let totalSum = 0;

    elements.each(function () {
        var packageWeight = $(this).clone().children().remove().end().text() //get the text while removing all children html elements
        let unit = $(this).find(`.units_${shipmentId}`).eq(0).html();
        if(unit === "ounces") {
            packageWeight = convertOuncesToPounds(packageWeight);
        }
        totalSum += parseInt(packageWeight, 10); // Add each value to the sum
    }); */

    if ($(`#carrier_id_${shipmentId}`).val() && $(`#service_id_${shipmentId}`).val() && $(`#package_id_${shipmentId}`).val()) {
        // Start rotation
        let angle = 0;
        const rotateButton = setInterval(() => {
            angle = (angle + 10); // Increase angle
            button.css("transform", `rotate(${angle}deg)`)
            .css('-webkit-transform', `rotate(${angle}deg)`)
            .css('-moz-transform', `rotate(${angle}deg)`)
            .css('-ms-transform', `rotate(${angle}deg)`); // Apply rotation
        }, 50); // Rotate every 100ms

        $.ajax({
            url: `/orders/${orderId}/shipment/${shipmentId}/rating`,
            method: "GET",
            dataType: "JSON",
            data: {
                //total_shipment_weight: totalSum,
            },
            success: (data) => {
                if (data) {
                    $(`#total_cost_${shipmentId}`).html(data.totalCost);
                    $(`#total_weight_${shipmentId}`).html(data.total_shipment_weight);
                    $(`#cost_per_pound_${shipmentId}`).html(data.cost_per_pound);

                }
            },
            error: (data, msg) => {
                console.log(data, msg);
            }
        })
        .then(() => {
            clearInterval(rotateButton); // Stop rotation
            button.css("transform", "rotate(0deg)")
            .css('-webkit-transform', "rotate(0deg)")
            .css('-moz-transform', "rotate(0deg)")
            .css('-ms-transform', "rotate(0deg)"); // Reset rotation
        })
        .catch(() => {
            clearInterval(rotateButton); // Stop rotation
            button.css("transform", "rotate(0deg)")
            .css('-webkit-transform', "rotate(0deg)")
            .css('-moz-transform', "rotate(0deg)")
            .css('-ms-transform', "rotate(0deg)"); // Reset rotation
        });
    }


}

function fetchBestRatings(orderId, shipmentId) {
    const button = $(`#autoRateCircle${shipmentId}`);

    if ($(`#carrier_id_${shipmentId}`).val() && $(`#service_id_${shipmentId}`).val() && $(`#package_id_${shipmentId}`).val()) {
        let angle = 0;
        const rotateButton = setInterval(() => {
            angle = (angle + 10);
            button.css("transform", `rotate(${angle}deg)`)
            .css('-webkit-transform', `rotate(${angle}deg)`)
            .css('-moz-transform', `rotate(${angle}deg)`)
            .css('-ms-transform', `rotate(${angle}deg)`);
        }, 50);
        $.ajax({
            url: `/orders/${orderId}/shipment/${shipmentId}/best-rating`,
            method: "GET",
            dataType: "JSON",
            success: (data) => {
                if (data) {
                    $(`#carrier_id_${shipmentId}`).val(data.carrier_id);
                    fetchCarrierService(data.carrier_id, `#service_id_${shipmentId}`, '/carriers/services');
                    fetchCarrierDefaultPackage(`#package_id_${shipmentId}`, data.carrier_id, '/carriers/defaults', 0); //{{$order->address?->residential ?? 0}}

                    $(`#service_id_${shipmentId}`).val(data.carrier_service_id);
                    $(`#package_id_${shipmentId}`).val(data.carrier_package_id);

                    $(`#total_cost_${shipmentId}`).html(data.totalCost);
                    $(`#total_weight_${shipmentId}`).html(data.total_shipment_weight);
                    $(`#cost_per_pound_${shipmentId}`).html(data.cost_per_pound);
                }
            },
            error: (data, msg) => {
                console.log(data, msg);
            }
        })
        .then(() => {
            clearInterval(rotateButton);
            button.css("transform", "rotate(0deg)")
            .css('-webkit-transform', "rotate(0deg)")
            .css('-moz-transform', "rotate(0deg)")
            .css('-ms-transform', "rotate(0deg)");
        })
        .catch(() => {
            clearInterval(rotateButton);
            button.css("transform", "rotate(0deg)")
            .css('-webkit-transform', "rotate(0deg)")
            .css('-moz-transform', "rotate(0deg)")
            .css('-ms-transform', "rotate(0deg)");
        });
    }
}

function allFetchRatings(orderId) {
    var shipments = $(".shipments");
    // Use .each() instead of $.each()
    shipments.each(function (index, element) {
        // Wrap the element in jQuery to call .val()
        var shipmentValue = $(element).val();
        fetchRatings(orderId, shipmentValue);
    });
}

function convertUOM(data, pkgId) {
    var weight = $("#weight_" + pkgId).val();
    switch (data) {
        case "ounces":
            $("#weight_" + pkgId).val(convertPoundsToOunces(weight));
            break;
        case "pounds":
            $("#weight_" + pkgId).val(convertOuncesToPounds(weight));
            break;
        default:
            console.log("Unit does not have conversion logic");
    }
}

function modalBody (data) {
    var modalText = `<div class="modal-body">
                <div class="row">
                    <div class="col-xl-8">
                        <div class="card  mb-2">
                            <div class="card-header bg-white h6 mb-0 p-3">
                                <i class="fa fa-dolly fa-lg fa-fw text-dark text-opacity-50 me-1"></i>Package Info
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    Package Name
                                    <input type="hidden" name="product_package_id" id="product_package_id_${data.id}" value="${data.product_package_id}">
                                    <input type="text" name="packname" id="packname_${data.id}" class="form-control" value="${data.name}">
                                    <p class="text-danger" id="packnamemsg_${data.id}"></p>
                                </div>
                            </div>
                        </div>

                        <div class="card border-0 mb-2">
                            <div class="card-header h6 mb-0 bg-none p-3">
                                <i class="fa fa-box fa-lg fa-fw text-dark text-opacity-50 me-1"></i> Package Details
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="mb-3">
                                            <div class="form-group">
                                                <label class="form-label">Weight</label>
                                                <div class="row gx-1">
                                                    <div class="col-4">
                                                        <div class="input-group">
                                                            <input type="number" id="weight_${data.id}" name="weight" step="0.1" placeholder="10" value="${data.weight}" class="form-control" />
                                                            <p class="text-danger" id="weightmsg"></p>
                                                        </div>
                                                    </div>
                                                    <div class="col-7">
                                                        <div class="input-group">
                                                            <select name="units" id="units_${data.id}" class="form-select" onchange="convertUOM(this.value, '${data.id}')">
                                                                <option value="pounds" ${ data.units==="pounds" ? "selected" : "" }>Pounds</option>
                                                                <option value="ounces" ${ data.units==="ounces" ? "selected" : "" }>Ounces</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label class="form-label">Package Size In Inches</label>
                                            <div class="row">
                                                <div class="col-4">
                                                    <div class="input-group">
                                                        <span class="input-group-text">W</span>
                                                        <input type="number" name="width" id="width_${
                                                data.id
                                            }" class="form-control" step="0.1" placeholder="10" id="width" value="${
        data.width
    }" />
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="input-group">
                                                        <span class="input-group-text">L</span>
                                                        <input type="number" name="length" id="length_${
                                                data.id
                                            }" class="form-control" step="0.1" placeholder="10" id="length" value="${
        data.length
    }" />
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="input-group">
                                                        <span class="input-group-text">H</span>
                                                        <input type="number" name="height" id="height_${
                                                data.id
                                            }" class="form-control" step="0.1" placeholder="10" id="height" value="${
        data.height
    }" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4">
                        <div class="card border-0 mb-4">
                            <div class="card-header h6 mb-0 bg-none p-3 d-flex">
                                <div class="flex-1">
                                    <div>Package References</div>
                                </div>
                            </div>
                            <div class="card-body fw-bold">
                                <div class="">
                                    <div class="mb-3">
                                        Reference 1:
                                        <input type="text" name="reference1" class="form-control" id="reference1_${
                                data.id
                            }" value="${data.reference1 ?? ""}" />
                                    </div>
                                    <div class="mb-3">
                                        Reference 2:
                                        <input type="text" name="reference2" class="form-control" id="reference2_${
                                data.id
                            }" value="${data.reference2 ?? ""}" />
                                    </div>
                                    <div class="mb-3">
                                        Copies
                                        <input type="number" name="print_copies" class="form-control" id="print_copies_${
                                data.id
                            }" value="${data.print_copies}" />
                                        <p class="text-danger" id="printCopiesmsg"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card border-0">
                            <div class="card-header h6 mb-0 bg-none p-3 d-flex">
                                <div class="flex-1">
                                    <div>Tags</div>
                                </div>
                            </div>

                            <div class="card-body fw-bold">
                                <div class="">
                                    <div class="mb-3">
                                        <input type="text" id="edit_package_tags_${
                                data.id
                            }" name="package_tags" class="form-control package_tags" value="${data.tags.map(
        (tag) => tag.name.en
    )}">
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="modal-footer d-flex justify-content-between">
                <a href="javascript:void(0)" class="btn btn-white" data-bs-dismiss="modal">Close</a>
                <div>
                    <button type="button" class="btn btn-sm btn-primary w-100px" id="editPackageButton" onclick="window.updatePkg('${data.orders_id}', '${data.shipments_id}', '${
        data.id
    }')">Update</button>
                </div>
            </div>`;

            $(".package_tags").tagit({
                showAutocompleteOnFocus: true,
                allowSpaces: true,
                beforeTagAdded: function(event, ui) {
                    // Check if the tag exists in availableTags
                    if ($.inArray(ui.tagLabel.toLowerCase(), availableTags.map(function(tag) { return tag })) == -1) {
                        return true;
                    }
                    return true;
                }
            });

            return modalText
}


function editPackage(packageId, shipmentId, orderId) {

    $.ajax({
        url: `/orders/package/${packageId}/single`,
        dataType:"JSON",
        method: "get",
        data: {
            shipment_id: shipmentId,
            order_id: orderId
        },
        success: (data, msg) => {

            var newModal = new bootstrap.Modal(document.getElementById("modal-edit-package"))
            newModal.show();

            $(".modal-details-body").html(modalBody(data))
            $(".package_tags").tagit({
                showAutocompleteOnFocus: true,
                allowSpaces: true,
                beforeTagAdded: function (event, ui) {
                    if (
                        $.inArray(
                            ui.tagLabel.toLowerCase(),
                            availableTags.map(function (tag) {
                                return tag;
                            })
                        ) == -1
                    ) {
                        return true;
                    }
                    return true;
                },
            });
        },
        error: (data, msg) => {
            console.log(data, msg)
        }
    })

}

function resetFirstShipment (url, shipmentId) {
    $.ajax({
        url: url,
        method: "get",
        dataType: "JSON",
        data: {
            shipment_id: shipmentId
        },
        success: (data, msg) => {
            if (data.data) {
                $(`#create_order_packages_${shipmentId}`).html("")
                $(`#order_packages_${shipmentId}`).html(
                    data.data.view
                );
            }

        },
        error: (data, msg) => {
            console.log(data, msg)
        }
    })
}

function ship(url) {
    $.ajax({
        url: url,
        method:"get",
        success: (data, msg) => {
            console.log(data, msg)
        },
        error: (data, msg) => {
            console.log(data, msg)
        }
    })
}

function popUpShipment(LabelId, printLabel = false, pkg = false, autoPop = false) {

    var URL = `/orders/labels/${LabelId}`;
    if (pkg) {
        URL += '?package=1';
    }

    var pdfIframe = $("#pdf-iframe");
    pdfIframe.attr("src", URL); // Set the iframe source
    pdfIframe.show(); // Show the iframe

    pdfIframe.on("load", function() {

        });

    if(printLabel !== false)
    {
        console.log("here");
        printJS({
            printable: URL,
            type: 'pdf',
            base64: false,
            onPrintDialogClose: () => { myModal.hide() }
        });
    }

    const myModal = new bootstrap.Modal(document.getElementById('modal-show-label'))
    if(autoPop) {
        $('#modal-show-label').on('hidden.bs.modal', function () {
            // Get the current URL
            const currentUrl = window.location.href;

            // Create a URL object to manipulate the URL
            const url = new window.URL(currentUrl);

            // Split the pathname into parts
            const pathParts = url.pathname.split('/');

            // Remove the last segment (3429 in this case)
            pathParts.pop();

            // Rebuild the pathname
            const newPath = pathParts.join('/');

            // Update the browser's URL without reloading
            history.pushState(null, '', newPath + url.search + url.hash);
        })
    }

    myModal.show();
}

function popUpMultiPackageLabel(orderId, shipmentId = null) {
    var URL = `/orders/labels/multi-package/${orderId}`;
    if (shipmentId) {
        URL += `?shipment_id=${shipmentId}`;
    }

    var pdfIframe = $("#pdf-iframe");
    pdfIframe.attr("src", URL); // Set the iframe source
    pdfIframe.show(); // Show the iframe

    pdfIframe.on("load", function() {
        // Optional: Handle load event
    });

    // Auto-print the multi-package warning label
    // printJS({
    //     printable: URL,
    //     type: 'pdf',
    //     base64: false,
    //     onPrintDialogClose: () => {
    //         const myModal = bootstrap.Modal.getInstance(document.getElementById('modal-show-label'));
    //         if (myModal) {
    //             myModal.hide();
    //         }
    //     }
    // });

    const myModal = new bootstrap.Modal(document.getElementById('modal-show-label'));
    myModal.show();
}

function fetchState(countryCode, url) {
    var reqJson = {
        country_code:countryCode ?? null
    }

    $.ajax({
        async: false,
        url: url,
        data: reqJson,
        success: (data, msg) => {
            var text = `<option value=""> - Select or create state - </option>`;

            $.each(data, (index, value) => {
                text += `<option value='${value.code}'>${value.name}</option>`
            })

            $("#state").html(text)
        },
        error: (data, msg) => {
            console.log(data, msg)
        }
    })
}

// ===================== Global Functions =====================

// --- Employee Assignments ---
window.saveAssignedEmpData = saveAssignedEmpData;
window.showAssignedEmployeeList = showAssignedEmployeeList;
window.editAssignedEmployeeEdit = editAssignedEmployeeEdit;
window.updateAssignedEmpData = updateAssignedEmpData;
window.resetModal = resetModal;
window.deleteAssignedEmployee = deleteAssignedEmployee;
window.sortList = sortList;
window.reorderPosition = reorderPosition;

// --- Shipping / Settings ---
window.selectAllCheckbox = selectAllCheckbox;
window.actionFunc = actionFunc;
window.applyActionValidation = applyActionValidation;
window.applyAction = applyAction;
window.showNotification = showNotification;
window.createPkgValidation = createPkgValidation;
window.addPkg = addPkg;
window.resetCreatePackgeForm = resetCreatePackgeForm;
window.resetPackageList = resetPackageList;
window.resetTopSection = resetTopSection;
window.resetMidSection = resetMidSection;
window.resetAll = resetAll;
window.removeAddedPkgRow = removeAddedPkgRow;
window.removeUpdatedPkgRow = removeUpdatedPkgRow;
window.updateJustAddedPkg = updateJustAddedPkg;

// --- Orders / Shipments / Packages ---
window.updateOrder = updateOrder;
window.addNewShipment = addNewShipment;
window.removeShipment = removeShipment;
window.confirmOrder = confirmOrder;
window.addNewProductRow = addNewProductRow;
window.updateProducts = updateProducts;
window.updateDetailsProduct = updateDetailsProduct;
window.deleteOrderProducts = deleteOrderProducts;
window.fetchRatings = fetchRatings;
window.fetchBestRatings = fetchBestRatings;
window.allFetchRatings = allFetchRatings;
window.convertUOM = convertUOM;
window.modalBody = modalBody;

// --- Package / Shipment / Label Functions ---
window.editPackage = editPackage;
window.resetFirstShipment = resetFirstShipment;
window.ship = ship;
window.popUpShipment = popUpShipment;
window.fetchState = fetchState;
window.updatePkg = updatePkg;
window.popUpMultiPackageLabel = popUpMultiPackageLabel;
window.fetchCarrierService = fetchCarrierService;
window.fetchCarrierDefaultPackage = fetchCarrierDefaultPackage;

});
